import { values } from 'lodash';

export const MODULE_RA = 'ra';
export const MODULE_ADMIN = 'admin';
export const MODULE_INSPECTION_COACH = 'inspection-coach';
export const MODULE_INSPECTION_CENTRE = 'improvement-hub';
export const MODULE_2BAP = '2bap';

export const MODULE_CODES = {
  MODULE_RA,
  MODULE_ADMIN,
  MODULE_INSPECTION_COACH,
  MODULE_INSPECTION_CENTRE,
  MODULE_2BAP
};
export const MODULE_CODES_LIST = values(MODULE_CODES);

export const MODULE_TYPE = {
  BASE: 1,
  URL: 2,
  HTML_CONTENT: 3,
};
export const isCustomModule = (module) => module.type && module.type !== MODULE_TYPE.BASE;

export default MODULE_CODES;


